/**
 * Usually used in beforeEach to allow the console to be used. Usually when a third party library emits warnings.
 *
 * An example might be when using non-iso dates in a test (eg. when testing invalid date input)
 *
  beforeEach(() => {
    ConsoleAllower.allowWarnings('Reasons...')
  })
 */
export class ConsoleAllower {
  private static INSTANCE = new ConsoleAllower()

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  private warningsAllowed = false
  private errorsAllowed = false
  private logsAllowed = false

  private visibleLogs = false

  public static areWarningsAllowed(): boolean {
    return this.INSTANCE.warningsAllowed
  }

  public static areErrorsAllowed(): boolean {
    return this.INSTANCE.errorsAllowed
  }

  public static areLogsAllowed(): boolean {
    return this.INSTANCE.logsAllowed
  }

  public static disallowWarnings(): void {
    this.INSTANCE.warningsAllowed = false
  }

  // Note: The string is a reason, so your fellow developers know why your allowing this
  // unfortunately, i can't name the variable due to linting.
  public static allowWarnings(_: string): void {
    this.INSTANCE.warningsAllowed = true
  }

  // Note: The string is a reason, so your fellow developers know why your allowing this
  // unfortunately, i can't name the variable due to linting.
  public static allowErrors(_: string): void {
    this.INSTANCE.errorsAllowed = true
  }

  public static disallowErrors(): void {
    this.INSTANCE.errorsAllowed = false
  }

  public static disallowLogs(): void {
    this.INSTANCE.logsAllowed = false
  }

  public static allowLogs(_whyAreYouEnablingTheseLogs: string): void {
    this.INSTANCE.logsAllowed = true
  }

  /**
   * Allow all types of logging, and prevent suppression of those logs in console.out
   *
   * IMPORTANT: Only to be used when writing tests. If you need to debug console logs
   */
  public static debugLogs(): void {
    this.INSTANCE.visibleLogs = true
    this.INSTANCE.logsAllowed = true
    this.INSTANCE.warningsAllowed = true
    this.INSTANCE.errorsAllowed = true
  }

  public static hideLogs(): void {
    this.INSTANCE.visibleLogs = false
  }

  public static areLogsVisible(): boolean {
    return this.INSTANCE.visibleLogs
  }
}
